/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { getCampaign } from './Header.services';
import { useToast } from '@welbe/web-design-system';

interface UseHeaderProps {
	campaignId: string;
}

type booksDatesProps = string[];

type changeDateType = 'start' | 'end' | null;

export const useHeader = ({ campaignId }: UseHeaderProps) => {
	const [isLoading, setLoading] = useState(false);
	const { toast } = useToast();
	const [isOpen, setOpen] = useState(false);
	const [startDateValue, setStartDateValue] = useState<string | null>(null);
	const [endDateValue, setEndDateValue] = useState<string | null>(null);
	const [bookDates, setBookDates] = useState<booksDatesProps>([]);
	const [changeDateType, setChangeDateType] = useState<changeDateType>(null);
	const [endCommunicationId, setEndCommunicationId] = useState<any>();
	const [startCommunicationId, setStartCommunicationId] = useState<any>();

	const fetchDates = async () => {
		setLoading(true);
		try {
			const {
				data: { content: dataCampaign },
			} = await getCampaign(campaignId);
			let startCommunication = {
				sendingDateTime: dataCampaign.dateStart,
				id: '',
			};
			let endCommunication = { sendingDateTime: dataCampaign.dateEnd, id: '' };

			if (dataCampaign.communications.length) {
				endCommunication =
					dataCampaign.communications.find((communication: any) =>
						communication.communicationType.id.includes('closing'),
					) || endCommunication;

				startCommunication =
					dataCampaign.communications.find((communication: any) =>
						communication.communicationType.id.includes('evaluation'),
					) || startCommunication;
			}

			setStartDateValue(
				dataCampaign.dateStart ? dataCampaign.dateStart.split('T')[0] : null,
			);

			setEndDateValue(
				dataCampaign.dateEnd ? dataCampaign.dateEnd.split('T')[0] : null,
			);

			setBookDates(
				dataCampaign.communications.map(
					(comunication: any) => comunication.sendingDateTime,
				),
			);

			setEndCommunicationId(endCommunication?.id);
		} catch (error) {
			toast.error(
				'Hubo un error al intentar procesar esta operación. Inténtalo de nuevo más tarde.',
			);
		} finally {
			setLoading(false);
		}
	};

	const handleToggleModal = (type?: 'start' | 'end') => {
		setOpen(!isOpen);
		type && setChangeDateType(type);
	};

	const handleCloseModal = () => {
		setOpen(false);
		setChangeDateType(null);
	};

	const handleSaveNewDate = () => setOpen(!isOpen);

	useEffect(() => {
		fetchDates();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campaignId]);

	return {
		changeDateType,
		handleToggleModal,
		handleSaveNewDate,
		startDateValue,
		endDateValue,
		isOpen,
		bookDates,
		isLoading,
		endCommunicationId,
		onRetryDates: fetchDates,
		startCommunicationId,
		handleCloseModal,
	};
};
